import { useTheme } from '@mui/styles';
import { ClientUser as ClientUserIcon } from '@tassat/icon';
import { muiTheme } from '@tassat/payments-themes';
import * as React from 'react';
import { components } from 'react-select';

import { WalletSelectOptionRendererProps } from './types';

const AddressBookDropdownComponent = <Option, IsMulti extends boolean>
(props: WalletSelectOptionRendererProps<Option, IsMulti>) => {
    const { selectProps, isSCForm } = props;
    const theme = useTheme<typeof muiTheme>();

    const iconColor = () => (isSCForm || selectProps?.menuIsOpen ?
        theme?.app?.applicationColors.enumColors.white || '#FFFFFF'
        : theme?.app?.applicationColors.fontColor || '#202020');

    return (
        components.DropdownIndicator && (
            <components.DropdownIndicator {...props}>
                <ClientUserIcon
                    iconColor={iconColor()}
                />
            </components.DropdownIndicator>
        )
    );
};

export default AddressBookDropdownComponent;